<template>

	<section>
		<container>
			<div class="stats-wrapper">
				<div class="headline">
					<h3>Focus and Determination</h3>
					<p style="width:85%;">StudySync has amassed an incredible amount of content in text, imagery, motion graphics and a variety of video productions. Our production personnel are prolific and extremely talented.
					</p>
				</div>
				<ul class="stats">
					<li><mark>30</mark>Feature-length Films Equivalent of StudySyncTV Episodes</li>
					<li><mark>1,000+</mark>Movie-like Previews for Books</li>
					<li><mark>500</mark>Hours of Professionally-recorded Audio</li>
					<li><mark>25,000+</mark>Original Poster Images and Motion Graphics</li>
					<li><mark>800</mark>Instructional Units</li>
					<li><mark>20,000+</mark>Lesson Plans</li>
				</ul>
			</div>
		</container>
	</section>

</template>

<script>

	export default {
		name: "AboutIntro1"
	}

</script>

<style lang="scss" scoped>
	@import "responsive-font";
	@import "media.scss";
	@import "list-style-reset.scss";

	section {
		padding:5vw 0;
		background: #FDB913;
	}

	.stats-wrapper {
		@include media(large) {
			display:flex;
		}
		& > * {
			flex: 1 1 50%;
		}
	}

	.headline {
		flex:1 0 50%;
		@include media(large) {
			margin-right:6vw;
		}
	}

	h3 {
		font-size:3.5rem; line-height:1.25; font-weight:400; color:#fff; text-transform:uppercase; max-width:37.5rem;
	}

	.stats {
		@include list-style-reset;
		display:flex; flex-wrap:wrap; color:#3D3D3D; font-weight:600; flex:1 0 50%;
		@include media(large) {
			margin:-1em -2em;
		}
		li {
			@include responsive-font(16);
			flex:0 0 50%; line-height: 1.3; margin:1em auto; padding-right: 3vw;
		}
		mark {
			@include responsive-font(45);
			line-height:1; color:#fff; font-family:"oswald"; display:block; margin-bottom:2.3rem; font-weight:400;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/OurCompany/AboutIntro1.vue